import { defineStore } from "pinia";
import { StoreModule } from "vue-app-utils";

export const useAppStore = defineStore("app", {
  ...StoreModule,
  state: () => ({
    ...StoreModule.state(),
    tournament: null,
    league: null,
    joinPlayerPromise: null,
    joinMemberPromise: null
  })
});
